import { Container, Grid, Box, Typography } from '@mui/material'
import ListaOpcoes from '../../../../utils/listaOpcoes'
import HeaderSession from '../../../../utils/headerSession'
import VerifyPermission from '../../../../utils/verifyPermission'
import { useSelector } from 'react-redux';

export default function Desalfandegar() {
    const definicoesSistema = useSelector((state) => state.definicoesSistema.data);

    return (
        <Container style={{ minHeight: '75vh' }}>
            <Box sx={{ display: { md: 'none' } }}>
                <HeaderSession title='DESALFANDEGAR' />
            </Box>

            <Grid container>
                <Grid margin={1} xs={12} md={5.7} item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40vh' }}>
                    <img src="/icones/Desalfandegar.svg" alt="" width={'50%'} />
                </Grid>
                <Grid margin={1} xs={12} md={5.7} item >

                    <Box width={'100%'} sx={{ display: { xs: 'none', md: 'block' } }}>
                        <HeaderSession title='DESALFANDEGAMENTO' />
                    </Box>

                    <Typography variant='subtitle1' fontSize={22} align="center" m={2} color={"secondary"}>
                        EMISSÃO DE DECLARAÇÃO PARA DESALFANDEGAMENTO
                    </Typography> 

                    {/* <ListaOpcoes nomeOpcao='Produtos de Controle Internacional' link='/utente/solicitacao/desalfandegamento-directo/Produtos-de-controle-internacional' /> */}
                    {/* <ListaOpcoes nomeOpcao='Produtos de Controle Nacional' link='/utente/solicitacao/desalfandegamento-directo/Produtos-de-controle-nacional' /> */}
                    <ListaOpcoes nomeOpcao='Medicamentos' link='/utente/solicitacao/desalfandegamento-directo/Medicamentos' />
                    <ListaOpcoes nomeOpcao='Suplemento Alimentar' link='/utente/solicitacao/desalfandegamento-directo/Suplemento-Alimentar' />
                    <ListaOpcoes nomeOpcao='Equipamento' link='/utente/solicitacao/desalfandegamento-directo/Equipamento' />
                    <ListaOpcoes nomeOpcao='Reagentes / TDRs' link='/utente/solicitacao/desalfandegamento-directo/Reagentes-TDRs' />

                    <br />
                    {/* solicitarNumeroDeImportador */}
                    <VerifyPermission permissions={definicoesSistema?.servicos} permission={'solicitarNumeroDeImportador'}>
                        <ListaOpcoes nomeOpcao='Solicitar declaração de desalfandegamento' link='/utente/solicitacao/numero-de-declaracao' />
                    </VerifyPermission>
                </Grid>

            </Grid>
            <br />
        </Container>
    )
}
